export type GTMEventParams = Record<string, unknown>;

type WindowWithDataLayer = Window & {
    dataLayer?: GTMEventParams[];
};

/**
 * Push a GA4-style event to the GTM dataLayer.
 *
 * Works for both real and "artificial" pageviews/events (add_to_cart,
 * mini_cart, experiment impressions, etc). Safe to call in non-browser
 * contexts (SSR) where it is a no-op.
 */
export default function pushGTMEvent(
    eventName: string,
    params: GTMEventParams = {}
): void {
    if (typeof window === 'undefined') {
        return;
    }

    const windowWithDataLayer = window as WindowWithDataLayer;

    if (!Array.isArray(windowWithDataLayer.dataLayer)) {
        windowWithDataLayer.dataLayer = [];
    }

    const { event: _event, ...rest } = params;

    windowWithDataLayer.dataLayer.push({
        event: eventName,
        ...rest,
    });
}
